module.exports = __webpack_public_path__ + "e325c3f2c8ce80884d95d455b9ddc24a.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/wei-dahua.png
// module id = 588
// module chunks = 30